// extracted by mini-css-extract-plugin
module.exports = {"root":"KioskRemains_root__3g-2f","remainValues":"KioskRemains_remainValues__m-Yq_"};